import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import {has, isEmpty} from "lodash";
import apiUser from "../../../apiUser";
import {Alert, ListGroupItem, Table} from "reactstrap";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import SearchInput from "../../../componentsReusable/AppTable/SearchInput";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import AdjustItemMpTableRow from "./AdjustItemMpTableRow";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_ADJUST} from "../Modules";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import TreeMenuNew, {DISPLAY_TYPE_TREE} from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";

const AdjustMainGroup = (params) => {
  return params.data.map(adjustMain => {

    return <div>
      <h6 className="font-weight-bold">{adjustMain.SubGroupName}</h6>

      <Table className="table-bordered table-sm table-hover">
        <tbody>
        {adjustMain.ItemMps.map(itemMp => <AdjustItemMpTableRow itemMp={itemMp} />)}
        </tbody>
      </Table>
    </div>
  })
}

const Adjust = props => {
  const { getApiPrimaryParams, showType, ident } = useTecRmi();
  const [textSearch, setTextSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [adjust, setAdjust] = useState([])
  const [mainGroups, setMainGroups] = useState({})
  const [componentSubgroupHtml, setComponentSubgroupHtml] = useState(null)

  useDidMountEffect(() => {
    fetchData()
  })

  useAfterUpdateEffect(() => {
    if(props.params[0]){
      fetchMainGroup(props.params[0])
    }
  }, [props.params])

  useAfterUpdateEffect(() => {
    fetchData()
  }, [textSearch])

  const fetchData = () => {
    setLoading(true)
    setAdjust([])
    setComponentSubgroupHtml(null)

    if(props.componentSubgroupId){
      apiUser.tecRmi.adjust.componentSubgroupHtml({
        ...getApiPrimaryParams(),
        componentSubgroupId: props.componentSubgroupId,
        printView: true,
      })
        .then(res => setComponentSubgroupHtml(res.data[0]))
        .finally(() => setLoading(false))
    }else{
      apiUser.tecRmi.adjust.list({
        ...getApiPrimaryParams(),
        textSearch,
      })
        .then(res => setAdjust(res.data))
        .finally(() => setLoading(false))
    }
  }

  const fetchMainGroup = (mainGroupId) => {
    apiUser.tecRmi.adjust.mainGroupData({
      ...getApiPrimaryParams(),
      mainGroupId,
    })
      .then(res => {
        setMainGroups({
          ...mainGroups,
          [mainGroupId]: res.data,
        })
      })
  }

  const getMappedItems = () => {
    return adjust.map(adjust => ({
      _data: adjust,
      active: adjust.MainGroupId === parseInt(props.params[0]),
      key: 'mainGroup' + adjust.MainGroupId,
      id: adjust.MainGroupId,
      label: adjust.MainGroupName,
      path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_ADJUST, 'uriName'), adjust.MainGroupId),
      component: <ListGroupItem>
        {
          has(mainGroups, adjust.MainGroupId.toString())
            ? <AdjustMainGroup data={mainGroups[adjust.MainGroupId.toString()]} />
            : <div className="text-center py-2"><i className="fas fa-spinner fa-spin fa-2x" /></div>

        }
      </ListGroupItem>
    }))
  }

  return (
    <div>
      <div className="d-flex justify-content-end align-items-center">
        <SearchInput
          onInputChanged={setTextSearch}
        />
      </div>

      <div className="mt-2">
        {
          loading
            ? <LoadingSpinner />
            : props.componentSubgroupId
              ? componentSubgroupHtml && <TecRmiSvgHtml html={componentSubgroupHtml}/>
              : isEmpty(adjust)
                ? <Alert color={'warning'} className="text-center">Brak danych</Alert>
                : <TreeMenuNew
                  actives={props.params}
                  displayType={DISPLAY_TYPE_TREE}
                  items={getMappedItems()}
                />
        }
      </div>
    </div>
  );
};

Adjust.defaultProps = {
  params: [],
};

Adjust.propTypes = {
  componentSubgroupId: PropTypes.number,
  mainGroupId: PropTypes.number,
};

export default Adjust;